export const loadingStates = [
  {
    animation: 'HOUSE',
    topText: 'Setting up your application...',
    bottomText: 'As a loyal customer, we can use information already on file to streamline the process.',
  },
  {
    animation: 'DATA',
    topText: 'Creating your financial profile...',
    bottomText: "We're verifying accounts and financial data, including available details about your credit.",
  },
  {
    animation: 'AVATAR',
    topText: 'Personalizing your experience...',
    bottomText: 'Just a bit longer while we customize your options, and offer you the best path forward.',
  },
  {
    animation: 'AVATAR',
    topText: 'Personalizing your experience...',
    bottomText: 'Wherever you are on your home buying journey, we want to best optimize your experience.',
  },
];
